import api from "../../../../services/api";

import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

import * as globalComponents from "../../../../components";

import "../../styles.css";

export default function CrefitoNormativesScene() {
  const { accessType, sectionName, normativeID } = useParams();
  const [title, setTitle] = useState(
    (() => {
      switch (sectionName) {
        case "resolucoes":
          return "Resoluções";
        case "portarias":
          return "Portarias";
        case "pareceres":
          return "Pareceres";
        default:
          return "";
      }
    })()
  );
  const [data, setData] = useState([]);

  const dir = [
    {
      title: "Legislação",
      url: `/${accessType}/legislacao`,
    },
    {
      title: `Normativas Crefito2`,
      url: `/${accessType}/legislacao/normativas_crefito2/${sectionName}`,
    },
    {
      title: `${title}`,
      url: `/${accessType}/legislacao/normativas_crefito2/${sectionName}`,
    },
  ];

  useEffect(() => {
    window.scroll(0, 0);
    async function fetchData() {
      await api
        .get(`/conteudo/${normativeID.split("_").pop()}`)
        .then((response) => {
          setData(response.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    fetchData();
  }, [normativeID]);

  useEffect(() => {
    setTitle(
      (() => {
        switch (sectionName) {
          case "resolucoes":
            return "Resoluções";
          case "portarias":
            return "Portarias";
          case "pareceres":
            return "Pareceres";
          default:
            return "";
        }
      })()
    );
  }, [sectionName]);

  return (
    <>
      <globalComponents.Header />

      <globalComponents.Breadcrumbs title={data.Titulo} dir={dir} />

      <div className="container">
        <div className="content-wrapper">
          <globalComponents.PageTitle
            title={data.Titulo}
            subtitle={data.Subtitulo}
            span={data.Data_Publicacao}
          />

          <div className="content-image">
            <img src={data.Nome_Arquivo} alt="" />
          </div>

          <div
            className="content-text"
            dangerouslySetInnerHTML={{ __html: data.Materia }}
          ></div>
        </div>
      </div>

      <globalComponents.Footer />
    </>
  );
}
